import { useSubmittedDocument } from "~/stores/useSubmittedDocument";

export const useSubmittedDocumentStore = (documentId: string) => {
  // const documentId = inject("documentId") as any;

  // console.log("DocumentId in store: ", activeDocumentId.value);

  return useSubmittedDocument(documentId)();
};
